import { createRoot } from "react-dom/client";
import "./editor.scss";
import MediaList from "../components/MediaList.component";

/**
 * Renders a view component with tabs and content.
 *
 * @return {JSX.Element} The rendered view component.
 */
export default function View() {
	const rootElement = document.getElementById("rootGallerySinglePage");
	const sectionStyleType = rootElement.getAttribute("data-sectionStyleType");
	const postId = rootElement.getAttribute("data-currentpostid");

	return (
		<>
			<div className="pt-10">
				<MediaList
					filterType="image_group"
					lightboxGroupName="typeImageGroup"
					sectionStyleType={sectionStyleType}
					currentPostId={postId}
				/>
			</div>
		</>
	);
}

const root = createRoot(document.getElementById("rootGallerySinglePage"));
root.render(<View />);
